<template>
    <div>
        <v-autocomplete
            v-model="model"
            :items="entries"
            :loading="isLoading"
            :search-input.sync="search"
            :rules="required ? requireRule : []"
            :dark="dark"
            color="primary"
            hide-no-data
            hide-selected
            :item-text="iddisplay"
            :item-value="idvalue"
            :label="label"
            return-object
            :outlined="!disabled && !notOutline"
            :disabled="disabled"
            clearable
            @change="selectAutocomplete"
            :name="name+'_input'" 
            :hide-details="hideDetails === true"
        ></v-autocomplete>
        <input type="hidden" :name="name" :value="getValue()" />
    </div>
</template>

<script>
import api              from '@/plugins/apisauceHeader.js';

export default {
    props: ['name','n','label','dark','url','iddisplay','idvalue','required','value','needWhere','disabled','modelEx','notOutline', 'returnFunction', 'hideDetails'],
    name: 'Autocomplete',
    data: () => ({
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        rURL: "",
        selected: false,
        requireRule: [
            r => (r != null) || "Essa campo é obrigatório!"
        ],
    }),

    methods:{
        selectAutocomplete(){
            if(this.returnFunction){
                this.$emit("select",{ value: this.getValue(), n: this.n, name: this.name, model: this.model});
                setTimeout(()=>{
                    this.model = null;
                },200)
            }
        },
        getValue(){
            return this.model ? this.model[this.idvalue] : '';
        },
        getSelected(){
            if((typeof(this.value) == "string" || typeof(this.value) == "number") && this.value != "" && this.model == null){
                this.isLoading = true;
                if(this.iddisplay == this.idvalue){
                    let items = {};
                    items[this.idvalue] = this.value;

                    this.count = 1;
                    this.entries = items;

                    this.model = items;
                    this.isLoading = false
                }else
                    api(localStorage.getItem("token")).get(`one/endpoint/${this.url}/${this.value}`)
                    .then(res => {
                        this.count = 1;
                        this.entries = res.data;

                        this.model = res.data[0];
                    })
                    .catch(() => {
                    })
                    .finally(() => (this.isLoading = false))
            }
        }
    },

    computed: {
        fields () {
            if (!this.model) return []

            return Object.keys(this.model).map(key => {
                return {
                    key,
                    value: this.model[key] || 'n/a',
                }
            })
        },
        items () {
            return this.entries.map(entry => {
                const Description = entry[this.iddisplay].length > this.descriptionLimit
                    ? entry[this.iddisplay].Description.slice(0, this.descriptionLimit) + '...'
                    : entry[this.iddisplay].Description

                return Object.assign({}, entry, { Description })
            })
        },
    },

    watch: {
        model(){
            this.$emit("change",{ value: this.getValue(), n: this.n, name: this.name, unidade: this.model['unidade'] });
        },
        search () {
            if(!this.search || this.search.length == 0) this.model = null;

            if (this.isLoading) return

            this.isLoading = true;

            api(localStorage.getItem("token")).get(`endpoint/${this.rURL}?search=${this.search}&noPagination=true`)
            .then(res => {
                this.count = res.data.endpoint.length;
                this.entries = res.data.endpoint;
            })
            .catch(() => {
            })
            .finally(() => (this.isLoading = false))
        },
        value(){
            this.getSelected();
        }
    },

    mounted(){
        this.rURL = this.needWhere ? `${this.url}/addwhere=idcliente:${localStorage.getItem("idcliente")}` : this.url;
        this.getSelected();
    }
}
</script>